import React from 'react';
import SideNavigation, { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import { useAuth } from 'AuthContext';

type NavigationItem = {
  type: 'link';
  text: string;
  href: string;
};

export default function Navigation() {
  const { isAuthenticated, role } = useAuth();

  // Public links available to all users (even when not authenticated)
  const publicLinks: readonly NavigationItem[] = [
    { type: 'link', text: 'Login', href: '/authentiate' }
  ] as const;

  // Links for authenticated users (both employees and admins)
  const employeeLinks: readonly NavigationItem[] = [
    { type: 'link', text: 'Create Request', href: '/create-request' },
    { type: 'link', text: 'My Requests', href: '/my-applications' },
    { type: 'link', text: 'Logout', href: '/signout' }
  ] as const;

  // Additional links only for admin users
  const adminLinks: readonly NavigationItem[] = [
    { type: 'link', text: 'All Requests', href: '/all-applications' },
    { type: 'link', text: 'External Accounts', href: '/external-accounts' },
    { type: 'link', text: 'Create Account', href: '/external-accounts/new' }
  ] as const;

  // Determine which links to show based on auth state and role
  let navigationItems: SideNavigationProps.Item[];
  
  if (!isAuthenticated) {
    navigationItems = [...publicLinks];
  } else if (role === 'admin') {
    navigationItems = [...adminLinks, ...employeeLinks];
  } else {

    // role === 'employee'
    navigationItems = [...employeeLinks];
  }
  return (
    <SideNavigation
      header={{ 
        href: '/home/index.html', 
        text: role === 'admin' ? 'Admin Panel' : 'User Portal'
      }}
      items={navigationItems}
    />
  );
}